/* import __COLOCATED_TEMPLATE__ from './custom-select.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { copy } from 'ember-copy';

export default class CustomSelect extends Component {
    tagName = '';

    idField = 'id';
    descriptionField = 'description';

    @action onChange() {
        let selectElement = document.querySelector(`#${this.selectId}`);
        if (selectElement) {
            let selectedIndex = this.prompt ? selectElement.selectedIndex - 1 : selectElement.selectedIndex;
            this.set('value', this.content[selectedIndex]);
        }

        if (this.onValueChange) this.onValueChange();
    }

    @computed('qaAttrValue', 'selectId') get internalQaAttrValue() {
        return this.qaAttrValue || this.selectId;
    }

    @computed('value', 'content.[]') get options() {
        let content = copy(this.content),
            tmpContent = [],
            id = this.value[this.idField];

        if (typeof content === 'undefined' || !Array.isArray(content)) return [];

        for (var i = 0; i < content.length; i++) {
            var item = content[i];
            tmpContent.push({
                id: item[this.idField],
                description: item[this.descriptionField],
                selected: item.id == id,
                isDisabled: item.isDisabled,
                divider: item.divider,
            });
        }

        return tmpContent;
    }
}
